import { Pipeable } from "./pipe";
export class DefaultContextListener {
    observed() {
        // console.warn(new Error('Called outside state context'));
    }
}
/**
 * Track observed values
 */
export var Context;
(function (Context) {
    Context.listener = new DefaultContextListener();
    function run(l, fn) {
        const old = Context.listener;
        Context.listener = l;
        try {
            return fn();
        }
        finally {
            Context.listener = old;
        }
    }
    Context.run = run;
})(Context || (Context = {}));
/**
 * Trackable observable
 */
export class State extends Pipeable {
    /** Read and track */
    get value() {
        Context.listener.observed(this.observable, true);
        return this.observable.result.getValue();
    }
    /** Read but don't track */
    get current() {
        Context.listener.observed(this.observable, false);
        return this.observable.result.getValue();
    }
}
//# sourceMappingURL=core.js.map